import React, { useState } from 'react'
import { Bar, Line, Radar, } from 'react-chartjs-2';
import Label from '../../svg/Label'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    RadialLinearScale,
    PointElement,
    LineElement,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    RadialLinearScale,
    PointElement,
    LineElement,
);

function NbrCommandEtatAge() {
    const [nbrCommandEtatAgeDate, setNbrCommandEtatAgeDate] = useState("aujourdhui")
    const [nbrCommandEtatAgeOrder, setNbrCommandEtatAgeOrder] = useState("etat")

    const setFilterDate = (filter_type) => {
        setNbrCommandEtatAgeDate(filter_type)
    }
    const setFilterOrder = (filter_type) => {
        setNbrCommandEtatAgeOrder(filter_type)
    }

    return (
        <div className='box'>
            <h2>
                <Label widthSize={"20px"} />
                <span>Nombre de Commande par Etat et Age :</span>
            </h2>
            <div className='statistique-content full-width'>
                <Bar
                    width={600}
                    height={400}
                    options={{ maintainAspectRatio: false }}
                    data={{
                        labels: ['Non Traité', 'Accepté', 'Refusé', 'Approuvé', 'Annulé', 'Financable', 'Non Financable', 'Rejeté', 'Controlé'],
                        datasets: [
                            {
                                label: 'Age [18,25]',
                                data: [10, 70, 30, 40, 80, 60, 25, 30, 40],
                                backgroundColor: ['rgba(75, 192, 192, 1)'],
                                hoverOffset: 4
                            },
                            {
                                label: 'Age [25,35]',
                                data: [40, 80, 30, 35, 45, 55, 65, 56, 22],
                                backgroundColor: ['rgba(54, 162, 235, 1)'],
                                hoverOffset: 4
                            },
                            {
                                label: 'Age [35,55]',
                                data: [50, 32, 45, 20, 48, 40, 22, 72, 23],
                                backgroundColor: ['rgba(255, 99, 132, 1)'],
                                hoverOffset: 4
                            },
                            {
                                label: 'Age [55,...]',
                                data: [49, 77, 38, 52, 42, 65, 33, 66, 28],
                                backgroundColor: ['rgba(255, 205, 86, 1)'],
                                hoverOffset: 4
                            },
                        ],
                    }}
                />
            </div>
            <div className='statistique-content half-width'>
                <Line
                    width={600}
                    height={400}
                    options={{ maintainAspectRatio: false }}
                    data={{
                        labels: ['Non Traité', 'Accepté', 'Refusé', 'Approuvé', 'Annulé', 'Financable', 'Non Financable', 'Rejeté', 'Controlé'],
                        datasets: [
                            {
                                label: 'Age [18,25]',
                                data: [10, 70, 30, 40, 80, 60, 25, 30, 40],
                                backgroundColor: ['rgba(75, 192, 192, 1)'],
                                borderColor: ['rgba(75, 192, 192, 1)'],
                                pointBackgroundColor: ['rgba(75, 192, 192, 1)'],
                                pointBorderColor: ['#fff'],
                                pointHoverBackgroundColor: ['#fff'],
                                pointHoverBorderColor: ['rgba(75, 192, 192, 1)'],
                            },
                            {
                                label: 'Age [25,35]',
                                data: [40, 80, 30, 35, 45, 55, 65, 56, 22],
                                backgroundColor: ['rgba(54, 162, 235, 1)'],
                                borderColor: ['rgba(54, 162, 235, 1)'],
                                pointBackgroundColor: ['rgba(54, 162, 235, 1)'],
                                pointBorderColor: ['#fff'],
                                pointHoverBackgroundColor: ['#fff'],
                                pointHoverBorderColor: ['rgba(54, 162, 235, 1)'],
                            },
                            {
                                label: 'Age [35,55]',
                                data: [50, 32, 45, 20, 48, 40, 22, 72, 23],
                                backgroundColor: ['rgba(255, 99, 132, 1)'],
                                borderColor: ['rgba(255, 99, 132, 1)'],
                                pointBackgroundColor: ['rgba(255, 99, 132, 1)'],
                                pointBorderColor: ['#fff'],
                                pointHoverBackgroundColor: ['#fff'],
                                pointHoverBorderColor: ['rgba(255, 99, 132, 1)'],
                            },
                            {
                                label: 'Age [55,...]',
                                data: [49, 77, 38, 52, 42, 65, 33, 66, 28],
                                backgroundColor: ['rgba(255, 205, 86, 1)'],
                                borderColor: ['rgba(255, 205, 86, 1)'],
                                pointBackgroundColor: ['rgba(255, 205, 86, 1)'],
                                pointBorderColor: ['#fff'],
                                pointHoverBackgroundColor: ['#fff'],
                                pointHoverBorderColor: ['rgba(255, 205, 86, 1)'],
                            },
                        ],
                    }}
                />
            </div>
            <div className='statistique-content half-width'>
                <Radar
                    width={600}
                    height={400}
                    options={{ maintainAspectRatio: false }}
                    data={{
                        labels: ['Non Traité', 'Accepté', 'Refusé', 'Approuvé', 'Annulé', 'Financable', 'Non Financable', 'Rejeté', 'Controlé'],
                        datasets: [
                            {
                                label: 'Age [18,25]',
                                data: [10, 70, 30, 40, 80, 60, 25, 30, 40],
                                backgroundColor: ['rgba(75, 192, 192, 1)'],
                                borderColor: ['rgba(75, 192, 192, 1)'],
                                pointBackgroundColor: ['rgba(75, 192, 192, 1)'],
                                pointBorderColor: ['#fff'],
                                pointHoverBackgroundColor: ['#fff'],
                                pointHoverBorderColor: ['rgba(75, 192, 192, 1)'],
                            },
                            {
                                label: 'Age [25,35]',
                                data: [40, 80, 30, 35, 45, 55, 65, 56, 22],
                                backgroundColor: ['rgba(54, 162, 235, 1)'],
                                borderColor: ['rgba(54, 162, 235, 1)'],
                                pointBackgroundColor: ['rgba(54, 162, 235, 1)'],
                                pointBorderColor: ['#fff'],
                                pointHoverBackgroundColor: ['#fff'],
                                pointHoverBorderColor: ['rgba(54, 162, 235, 1)'],
                            },
                            {
                                label: 'Age [35,55]',
                                data: [50, 32, 45, 20, 48, 40, 22, 72, 23],
                                backgroundColor: ['rgba(255, 99, 132, 1)'],
                                borderColor: ['rgba(255, 99, 132, 1)'],
                                pointBackgroundColor: ['rgba(255, 99, 132, 1)'],
                                pointBorderColor: ['#fff'],
                                pointHoverBackgroundColor: ['#fff'],
                                pointHoverBorderColor: ['rgba(255, 99, 132, 1)'],
                            },
                            {
                                label: 'Age [55,...]',
                                data: [49, 77, 38, 52, 42, 65, 33, 66, 28],
                                backgroundColor: ['rgba(255, 205, 86, 1)'],
                                borderColor: ['rgba(255, 205, 86, 1)'],
                                pointBackgroundColor: ['rgba(255, 205, 86, 1)'],
                                pointBorderColor: ['#fff'],
                                pointHoverBackgroundColor: ['#fff'],
                                pointHoverBorderColor: ['rgba(255, 205, 86, 1)'],
                            },
                        ],
                    }}
                />
            </div>
            <div className='filter'>
                <div>
                    <ul>
                        <li className={nbrCommandEtatAgeDate === "aujourdhui" ? "filter-active" : ""} onClick={() => setFilterDate('aujourdhui')}>Aujourd'hui</li>
                        <li className={nbrCommandEtatAgeDate === "mois" ? "filter-active" : ""} onClick={() => setFilterDate('mois')}>Mois_En_Cours</li>
                        <li className={nbrCommandEtatAgeDate === "annee" ? "filter-active" : ""} onClick={() => setFilterDate('annee')}>Année_En_Cours</li>
                        <li className={nbrCommandEtatAgeDate === "intervalle" ? "filter-active" : ""} onClick={() => setFilterDate('intervalle')}>
                            Intervalle
                            <div className='interval-pop-up'>
                                <div className='row'>
                                    <div className="form-group col-lg-6">
                                        <label>Date Debut</label>
                                        <input type="date" className="form-control" placeholder="Date Debut" required />
                                    </div>
                                    <div className="form-group col-lg-6">
                                        <label>Date Fin</label>
                                        <input type="date" className="form-control" placeholder="Date Fin" required />
                                    </div>
                                    <div className='text-center'>
                                        <span onClick={() => setFilterDate('intervalle')}>Valider</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li className={nbrCommandEtatAgeOrder === "etat" ? "filter-active" : ""} onClick={() => setFilterOrder('etat')}>Ordonner_Par_Etat</li>
                        <li className={nbrCommandEtatAgeOrder === "nbrcommand" ? "filter-active" : ""} onClick={() => setFilterOrder('nbrcommand')}>Ordonner_Par_Nombre_De_Commandes</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default NbrCommandEtatAge